__turbopack_context__.v({
  "banner-img": "Wnq_ra_banner-img",
  "banner-main": "Wnq_ra_banner-main",
  "banner-sub": "Wnq_ra_banner-sub",
  "buttonBox": "Wnq_ra_buttonBox",
  "card-footer-text": "Wnq_ra_card-footer-text",
  "cardContainer": "Wnq_ra_cardContainer",
  "container": "Wnq_ra_container",
  "content": "Wnq_ra_content",
  "darkBG": "Wnq_ra_darkBG",
  "divider": "Wnq_ra_divider",
  "error-message": "Wnq_ra_error-message",
  "form-group": "Wnq_ra_form-group",
  "google-btn": "Wnq_ra_google-btn",
  "illustration": "Wnq_ra_illustration",
  "inputBox": "Wnq_ra_inputBox",
  "intro": "Wnq_ra_intro",
  "large-4": "Wnq_ra_large-4",
  "left": "Wnq_ra_left",
  "lightBG": "Wnq_ra_lightBG",
  "newLetterContainer": "Wnq_ra_newLetterContainer",
  "newsletter-bridge": "Wnq_ra_newsletter-bridge",
  "newsletter-card": "Wnq_ra_newsletter-card",
  "newsletter-columns": "Wnq_ra_newsletter-columns",
  "newsletter-grid": "Wnq_ra_newsletter-grid",
  "newsletter-header": "Wnq_ra_newsletter-header",
  "newsletter-promo": "Wnq_ra_newsletter-promo",
  "newsletter-promo__container": "Wnq_ra_newsletter-promo__container",
  "newsletter-section": "Wnq_ra_newsletter-section",
  "overlay": "Wnq_ra_overlay",
  "right": "Wnq_ra_right",
  "submit-btn": "Wnq_ra_submit-btn",
  "textCenter": "Wnq_ra_textCenter",
});
